import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=54da4408&scoped=true&"
import script from "./AppModal.vue?vue&type=script&lang=js&"
export * from "./AppModal.vue?vue&type=script&lang=js&"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=54da4408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da4408",
  null
  
)

export default component.exports